document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector('.presale-video-list');
    const isEnableSwiper = container.getAttribute('data-swiper') === 'true';
    const swiperContainers = container.querySelectorAll('.category-container.swiper-container');
    const enabledSwiperPagecount = container.getAttribute('data-enabled-swiper-pagecount') === 'true';
    const enableArrow = container.getAttribute('data-enable-arrow') === 'true';
    const enableNormalizeSlide = container.getAttribute('data-enable-normalizeSlide') === 'true';
    const swiperNumPC = container.getAttribute('data-swiper-num-pc');
    const swiperNumMB = container.getAttribute('data-swiper-num-mb');
    const blockSize = container.querySelectorAll('.video-item').length;

    swiperContainers.forEach(wrapper => {
        // 将弹窗从swiper里面搬到swiper外面，恢复弹窗的fixed参考是窗口
        const videoModalList = wrapper.nextElementSibling;
        const videoModals = wrapper.querySelectorAll('.product-media-video-container');
        // videoModalList.appendChild(videoModals);
        videoModals.forEach(modal => {
            videoModalList.appendChild(modal);
        })
    })
    if (isEnableSwiper) {
        const swiperSettings = JSON.parse(container.getAttribute('data-swiper-settings'));
        if (enabledSwiperPagecount) {
            swiperSettings.on = {
                slideChangeTransitionEnd: function () {
                    let index = this.activeIndex;
                    if (+index + 1 > blockSize) {
                        index = blockSize - 1;
                    }
                    let temp = +index + 1 > 10 ? +index + 1 : "0" + (+index + 1)
                    container.querySelector('.page-count .current').textContent = temp;
                }
            }
        }
        if (enableArrow) {
            swiperSettings.navigation = {
                nextEl: '.presale-video-list .button-content .swiper-button-next',
                prevEl: '.presale-video-list .button-content .swiper-button-prev',
            }
        }
        if (enableNormalizeSlide) {
            swiperSettings.normalizeSlideIndex = false;
        }
        swiperSettings.slidesPerGroup = 1;
        if (swiperNumPC) {
            swiperSettings.slidesPerView = +swiperNumPC;
        }
        if (swiperNumMB) {
            swiperSettings.breakpoints = {
                850: {
                    slidesPerView: swiperNumMB,
                }
            }
        }
        swiperContainers.forEach(wrapper => {
            // 创建swiper
            const swiper = new Swiper(wrapper, swiperSettings);

        })

    } else {
        return;
    }

})